<template>
  <nav
    v-if="items.length"
    v-bind="$attrs"
    class="flex items-center text-gray-600 text-xs uppercase"
  >
    <template v-for="(item, key) in items" :key="key">
      <Icon
        v-if="key"
        type="angle-right"
        class="mx-1 text-gray-500"
        size="2"
      />

      <Link
        v-if="'href' in item"
        class="hover:underline"
        v-bind="item"
      />

      <span v-else class="cursor-default">
        {{ item.text }}
      </span>
    </template>
  </nav>
</template>

<script>
import Icon from 'Web/Shared/Icon.vue';
import Link from 'Web/Shared/Link.vue';

export default {
  inheritAttrs: false,
  components: {
    Icon,
    Link,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    }
  }
}
</script>
